import React from 'react'
import { observer } from 'mobx-react'
import { Model, useValue, WhenModel } from '@morningtrain/react-resources'
import RevenueBudget from 'widgets/smartviews/partials/RevenueBudget'
import SalaryExpenditure from 'widgets/smartviews/partials/SalaryExpenditure'

function PeriodRevenueOverview (props) {
  const scheduleId = useValue('id')

  return (
    <WhenModel>
      <Model resourceName='shifts.schedule' operationName='summary' id={scheduleId} clean>
        <RevenueBudget week={props.week} />
        <SalaryExpenditure week={props.week} />
      </Model>
    </WhenModel>
  )
}

export default observer(PeriodRevenueOverview)
